<template>
  <v-footer
    height="auto"
    color="#29339b"
  >
    <v-row
      justify="center"
    >
      <v-btn
        color="white"
        text
        rounded
        :to="{ name: 'Home' }">Home
      </v-btn>
      <v-btn
        color="white"
        text
        rounded
        :to="{ name: 'Meet' }">Meet Our Staff
      </v-btn>
      <v-btn
        color="white"
        text
        rounded
        :to="{ name: 'About' }">About
      </v-btn>
      <v-btn
        color="white"
        text
        rounded
        :to="{ name: 'Contact' }">Contact
      </v-btn>

      <v-col
        align="center"
        cols="12"
        class="footerText"
      >
        &copy;2019 — <strong>Mind Body Health Center LLC</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>

export default {
  name: "Footer"
}

</script>

<style>

.footer {
  margin-top: 20px;
}

.footerText {
  color: white;
}
</style>
